/**
 * Generate an ID to be used in the mocks
 * @param {base} string Base name of the ID, generaly the name of the model
 * @param {index} number Number to decrement, starting at 10000
 * @returns {string} Generated id
 */
function generateId(base, index) {
    return `${base}-id-${10000 - index}`;
}

export { generateId };
